import { Modal } from "@flash-tecnologia/flamingo-ui-modal";
import dispatchToast from "@utils/dispatch-toast";

interface DeleteCompanyModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const DeleteCompanyModal = ({
  open,
  onClose,
  onSubmit,
}: DeleteCompanyModalProps) => {
  const handleDeleteCompanySubmit = async () => {
    try {
      dispatchToast({
        content: "Empresa excluída com sucesso!",
        type: "success",
      });
      onSubmit();
    } catch (error) {
      dispatchToast({
        content:
          "Ocorreu um erro ao excluir esta empresa. Tente novamente mais tarde.",
        type: "error",
      });
    }
  };

  return (
    <Modal.Root open={open} onOpenChange={() => open && onClose()} size="small">
      <Modal.Content.Root>
        <Modal.Content.Highlight
          customIconName="IconAlertCircle"
          size="compact"
          type="warning"
        >
          Atenção!
        </Modal.Content.Highlight>
        <Modal.Content.Title>
          Tem certeza que deseja excluir esta empresa?{" "}
        </Modal.Content.Title>
        <Modal.Content.Description>
          Essa ação é permanente e não poderá ser desfeita.
        </Modal.Content.Description>
        <Modal.Content.Footer>
          <Modal.Content.Footer.CancelButton onClick={onClose}>
            Cancelar
          </Modal.Content.Footer.CancelButton>
          <Modal.Content.Footer.PrimaryButton
            variantType="attention"
            onClick={handleDeleteCompanySubmit}
          >
            Excluir empresa
          </Modal.Content.Footer.PrimaryButton>
        </Modal.Content.Footer>
      </Modal.Content.Root>
    </Modal.Root>
  );
};
